import { VhvCard } from "@vhv/ui-kit-react";
import styles from "./notfound.module.scss";
import React from "react";
import { MessageHelper } from "../../helpers/MessageHelper";
export const NotFoundPage = () => {
    return React.createElement("div", { className: styles.mainContainer },
        React.createElement(VhvCard, { className: styles.forbiddenContainer },
            React.createElement(MessageHelper, { msgKey: "pageNotFound" })));
};
